var _path, _path2, _path3, _line, _line2, _line3, _path4, _path5, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiuradar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.45035L26.0204 8.97961L29.5497 17.5L26.0204 26.0204L17.5 29.5497L8.97961 26.0204L5.45035 17.5L8.97961 8.97961L17.5 5.45035Z",
    stroke: "#383838",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.50606L24.5684 10.4339L27.4963 17.5023L24.5684 24.5707L17.5 27.4986L10.4316 24.5707L7.50374 17.5023L10.4316 10.4339L17.5 7.50606Z",
    stroke: "#383838",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.6337L19.525 15.4725L20.3637 17.4974L19.525 19.5224L17.5 20.3611L15.475 19.5224L14.6363 17.4974L15.475 15.4725L17.5 14.6337Z",
    stroke: "#383838",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 26.3215,
    y1: 8.93479,
    x2: 8.98272,
    y2: 26.2736,
    stroke: "#383838",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 29.7344,
    y1: 17.6906,
    x2: 5.18174,
    y2: 17.6906,
    stroke: "#383838",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.3,
    x2: 24.5526,
    y2: -0.3,
    transform: "matrix(0 -1 -1 0 17.4609 29.6641)",
    stroke: "#383838",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.88059L22.8872 12.112L25.1187 17.4992L22.8872 22.8865L17.5 25.1179L12.1128 22.8865L9.88135 17.4992L12.1128 12.112L17.5 9.88059Z",
    stroke: "#383838",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.4742L21.0531 13.946L22.5249 17.4991L21.0531 21.0522L17.5 22.524L13.9469 21.0522L12.4751 17.4991L13.9469 13.946L17.5 12.4742Z",
    stroke: "#383838",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 26.034,
    y1: 26.2903,
    x2: 8.65971,
    y2: 8.916,
    stroke: "#383838",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiuradar);
export default __webpack_public_path__ + "static/media/biểu đồ radar.8b3ba6fa53da111e08b46034cf4e32de.svg";
export { ForwardRef as ReactComponent };